import { render, staticRenderFns } from "./MyCourseForm.vue?vue&type=template&id=666e5a3a"
import script from "./MyCourseForm.vue?vue&type=script&lang=js"
export * from "./MyCourseForm.vue?vue&type=script&lang=js"
import style0 from "./MyCourseForm.vue?vue&type=style&index=0&id=666e5a3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports